export default "__VITE_ASSET__Dqez$z5s__"